import { Component, Input, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { Subscriber } from 'rxjs';
import { RouteExecutor } from '../../@core/application-router/route.executor';
import {
    ErrorWrapper,
    ResponseWrapper,
} from '../../@shared/models/response-wrapper.model';
import { LFPDATA } from './collection-listing-filter-page.data';
import { MarcheAPIService } from '../../@core/api/marche-api.service';
import { ApplicationRouterService } from '../../@core/application-router/application-router.service';
import { FooterPageService } from '../../footer/footer-page.service';
import { plainToClassFromExist } from 'class-transformer';

@Component({
    selector: 'app-collection-listing-filter-page',
    templateUrl: './collection-listing-filter-page.html',
    styleUrls: ['./collection-listing-filter-page.scss'],
})
export class CollectionListingFilterPageComponent
    extends RouteExecutor
    implements OnInit
{
    static readonly COLP_FILTERS_API = '/clfp/v2';
    errors: ErrorWrapper[] = [];
    pageData: LFPDATA = new LFPDATA();
    ghostFilter = new Array(4);
    @Input() filter: { [p: string]: string | string[] } = {};
    @Input() asHTMLTag = false;
    @Input() collectionFilterVisible = false;
    selectedFilter: Map<string, Array<string>> = new Map();

    SELECTED_FILTERS = 'SELECTED_FILTERS';
    SELECTED_FILTER_KEYS = 'SELECTED_FILTER_KEYS';
    index: number = -1;

    constructor(
        private marcheAPIService: MarcheAPIService,
        applicationRouterService: ApplicationRouterService,
        private activatedRoute: ActivatedRoute
    ) {
        super(applicationRouterService);
        this.processLink('/fn/?value=false&action=footer-show');
        this.activatedRoute.queryParams.subscribe(param => {
            this.filter = param;
            this.fetchListingFilters();
        });
    }

    ngOnInit() {}

    fetchListingFilters() {
        const subscriber = Subscriber.create<ResponseWrapper<LFPDATA> | null>(
            value => {
                if (value?.success) {
                    plainToClassFromExist(this.pageData, value.data);
                } else {
                    plainToClassFromExist(this.errors, value?.errors);
                }
            },
            error => {},
            () => {}
        );

        this.marcheAPIService
            .getRequest<ResponseWrapper<LFPDATA> | null>(
                CollectionListingFilterPageComponent.COLP_FILTERS_API,
                this.filter
            )
            .subscribe(subscriber);
    }

    backButton() {
        window.history.back();
    }

    executeFunctionLink(id: string, query: { [p: string]: string | string[] }) {
        switch (query?.action) {
            case 'close-popup': {
                this.backButton();
                break;
            }
            case 'filter-select': {
                this.recordSelection(
                    query.filterKey.toString(),
                    query.filterValue.toString(),
                    query.selected.toString() == 'true'
                );
                break;
            }
            case 'filter-select-desktop': {
                this.recordSelection(
                    query.filterKey.toString(),
                    query.filterValue.toString(),
                    query.selected.toString() == 'true'
                );
                //@ts-ignore
                this.applyFilterDesktop(this.pageData?.leftButton?.link);
                break;
            }
            case 'apply-filter': {
                console.log(query, 'apply');
                this.applyFilter(query.baseUrl.toString());
                break;
            }
            default: {
                this.applicationRouterService
                    .executeFunctionLink(id, query)
                    .subscribe(res => {
                        res?.data.redirects.forEach((link: string) => {
                            this.processLink(link);
                        });
                    });
            }
        }
    }
    recordSelection(filterKey: string, filterValue: string, selected: boolean) {
        let filter: undefined | Array<string> = Array<string>();
        if (this.selectedFilter.has(filterKey)) {
            filter = this.selectedFilter.get(filterKey);
        }
        if (selected) {
            filter?.push(filterValue);
        } else {
            filter = filter?.filter(
                existingItem => existingItem !== filterValue
            );
        }
        if (filter?.length == 0) {
            this.selectedFilter.delete(filterKey);
        } else {
            if (filter != null) this.selectedFilter.set(filterKey, filter);
        }
        console.log(this.selectedFilter, 'finalSelected');
    }

    applyFilter(baseUrl: string) {
        const selectedFilters = Array.from(this.selectedFilter)
            .map(([key, values]) => `${key}~${values.join('_')}`)
            .join(',');
        const selectedFilterKeys = `selected~${Array.from(
            this.selectedFilter.keys()
        ).join('_')}`;

        baseUrl = baseUrl.replace('SELECTED_FILTERS', selectedFilters);
        baseUrl = baseUrl.replace('SELECTED_FILTER_KEYS', selectedFilterKeys);
        console.log(baseUrl, 'basurl');
        this.processLink(baseUrl);
    }
    applyFilterDesktop(link: string) {
        if (this.selectedFilter.size > 0) {
            this.processLink(link);
        } else {
            //@ts-ignore
            this.processLink(this.pageData?.rightButton?.link);
        }
    }
    process(link: string, i: number) {
        this.index = i;
        this.processLink(link);
    }
}
